import React, { useEffect, useState } from 'react';
import styles from './hero.module.css';
import Slider1 from '../../icon/SliderImage.png';
import Slider2 from '../../icon/sliderLargeimage.png';
import Slider3 from '../../icon/KopresearchImage.png';
import Slider4 from '../../icon/Research.jpg';

import { NavLink } from 'react-router-dom';

const slides = [
  {
    heading: 'Explore our Product Range',
    text: 'Comprehensive selection meeting diverse industry needs.',

    button: 'OUR PRODUCTS',
    link: '/products',
  },
  {
    heading: 'Stay Updated: Latest News from KOPL',
    text: 'Get the latest on product developments, achievements, and our global presence at Kumar Organic Products Limited.',
    button: 'READ MORE',
    link: '/all-media',
  },
  {
    heading: 'Biotechnology at KOP Research Range',
    text: 'Biotechnology at Kumar Organic Products Limited Harnessing innovation in biotechnology to drive sustainable solutions and advancements in the industry.',
    button: 'KNOW MORE ABOUT OUR BIOTECH',
    link: '/biotech-centre',
  },
  {
    heading: 'Innovation Hub: KOP Research Centre',
    text: 'Your Extended R&D Partner',
    button: 'VISIT KRC',    
    link: '/research-centre',
  },
];

const images = [Slider1, Slider2, Slider4, Slider3];
const totalImages = images.length;
const radius = 300;
const initialAngleOffset = -90; // Top image

const Hero: React.FC = () => {
  const initialActiveIndex = Math.round(totalImages / 2) % totalImages;
  const [index, setIndex] = useState(initialActiveIndex);
  const totalSlides = slides.length;
  const rotationSpeed = 8000;

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % totalSlides);
    }, rotationSpeed);

    return () => clearInterval(interval);
  }, [totalSlides]);

  return (
    <div className={styles.heroContainer}>
      {/* Text Slider */}
      <div className={styles.textSliderWrapper}>
        <div
          className={styles.textSlider}
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {slides.map((slide, i) => (
            <div className={styles.slide} key={i}>
              <h1>{slide.heading}</h1>
              <p>{slide.text}</p>
              <NavLink to={slide.link} className={styles.buttonLink}>
                <button>{slide.button}</button>
              </NavLink>
            </div>
          ))}
        </div>
        <div className={styles.dots}>
          {slides.map((_, i) => {
            const isActive = i === index;
            return (
              <span
                key={i}
                className={`${styles.dot} ${isActive ? styles.activeDot : ''}`}
                onClick={() => setIndex(i)}
              />
            );
          })}
        </div>
      </div>

      {/* Image Wheel */}
      <div className={styles.imagewheel}>
        <div className={styles.wheelPosition}>
          {images.map((img, i) => {
          
            const adjustedIndex = (i - index + totalImages) % totalImages;
            const angleDeg = (360 / totalImages) * adjustedIndex + initialAngleOffset;
            const angleRad = (angleDeg * Math.PI) / 180;
            const x = radius * Math.sin(angleRad);
            const y = radius * Math.cos(angleRad) * 0.8;

            const isActive = i === index;
            const beforeIndex = (index - 1 + totalImages) % totalImages;
            const afterIndex = (index + 1) % totalImages;

            let currentHeight = 190;
            let currentWidth = currentHeight * 1.2;
            let currentMarginLeft = -currentWidth / 2;
            let currentMarginTop = -currentHeight / 2;
            let currentOpacity = 0.6;
            let rotateZ = '0deg';
            let className = '';

            if (isActive) {
              currentHeight = 260;
              currentWidth = currentHeight * 1.2;
              currentMarginLeft = -currentWidth / 2;
              currentMarginTop = -currentHeight / 2;
              currentOpacity = 1;
              className = styles.activeImage;
            } else if (i === beforeIndex) {
              currentHeight = 180;
              currentWidth = currentHeight * 1.4;
              currentMarginLeft = -currentWidth / 4.7;
              currentMarginTop = -currentHeight / 1.9;
              currentOpacity = 0.7;
              rotateZ = '22deg';
              className = styles.beforeactive;
            } else if (i === afterIndex) {
              currentHeight = 180;
              currentWidth = currentHeight * 1.4;
              currentMarginLeft = -currentWidth / 4.6;
              currentMarginTop = -currentHeight / 4;
              currentOpacity = 0.7;
              rotateZ = '-13deg';
              className = styles.afteractive;
            }

            return (
              <img
                key={i}
                src={img}
                alt={`img-${i}`}
                className={`${className} commonImage`}
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  width: `${currentWidth}px`,
                  height: `${currentHeight}px`,
                  marginLeft: `${currentMarginLeft}px`,
                  marginTop: `${currentMarginTop}px`,
                  transform: `translate(${x}px, ${y}px) rotateZ(${rotateZ})`,
                  transition:
                    'transform 1s ease, opacity 1s ease, width 1s ease, height 1s ease, margin-top 1s ease, margin-left 1s ease',
                  opacity: currentOpacity,
                  zIndex: isActive ? 2 : 1,
                  borderRadius: '5px',
                  boxShadow: isActive ? '0 0 20px rgba(0,0,0,0.5)' : 'none',
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Hero;